import { render } from "./ForgotPasswordToken.vue?vue&type=template&id=5782fe7c"
import script from "./ForgotPasswordToken.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordToken.vue?vue&type=script&lang=js"
script.render = render

export default script